import { useTranslation } from './useTranslation';

const contentKeys = new Set(['content', 'blockName']);

const createCMSPageEntities = pageData => {
  const createEntity = (key, entity, prefix, result) => {
    const prefixedKey = prefix ? `${prefix}.${key}` : key;
    if (Array.isArray(entity)) {
      entity.forEach((item, index) => {
        createEntity(index, item, prefixedKey, result);
      });
    } else if (typeof entity === 'object' && entity !== null) {
      for (let subKey in entity) {
        createEntity(subKey, entity[subKey], prefixedKey, result);
      }
    } else if (typeof entity === 'string' && contentKeys.has(key)) {
      result[prefixedKey] = entity;
    }
  };
  const entity = {};
  for (let key in pageData) {
    createEntity(key, pageData[key], null, entity);
  }

  return entity;
};

const createCMSPageObj = (pageData, entities) => {
  const putDataInPlace = (ref, keys, val) => {
    const withoutLastKeys = keys.slice(0, -1);
    const lastKey = keys[keys.length - 1];
    let current = ref;
    current = withoutLastKeys.reduce((acc, key) => {
      if (acc[key] === undefined) {
        acc[key] = {};
      }
      acc = acc[key];
      return acc;
    }, current);
    current[lastKey] = val;
  };
  for (let key in entities) {
    const keys = key.split('.');
    putDataInPlace(pageData, keys, entities[key]);
  }
  return pageData;
};

export function useCMSPageTranslations(pageAssetsData, pageId) {
  const pageData = pageAssetsData?.[pageId]?.data;
  if (!pageData) {
    return {};
  }
  const pgData = JSON.parse(JSON.stringify(pageData));
  const cmsPageEntities = createCMSPageEntities(pageData);
  const { translation, translationInProgress } = useTranslation({
    batchId: pageId,
    translationEntries: cmsPageEntities,
  });
  const assetData = createCMSPageObj(pgData, translation);
  return { assetData, translationInProgress };
}
